import React, { Component } from 'react';
import axios from 'axios';
import _groupBy from 'lodash/groupBy';

import endpoints from '../../../../config/endpoints';

class DomansList extends Component {
	constructor(props) {
		super(props);
		this.state = { offer_domains_list: [] };
	}
	componentDidMount() {
		const { offer_id } = this.props;
		axios.get(`${endpoints.OFFERS.BASE}/${offer_id}/promo-attributes`)
			.then(data => this.setState({ offer_domains_list: data.data }));
	}

	render() {
		const { offer_domains_list } = this.state;
		const groupedByType = _groupBy(offer_domains_list, 'type');
		return (
			<span className="domains-count-popup">
				{
					Object.entries(groupedByType)
						.map(([key, val], index) =>
							<p key={index}>{key}: {val && val.length}</p>
						)
				}
				<p>Total {offer_domains_list.length}</p>
			</span>
		);
	}
}

export default DomansList;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/domains-count.js